import { render, staticRenderFns } from "./md-lazy.vue?vue&type=template&id=6c71d9ec&"
import script from "./md-lazy.vue?vue&type=script&lang=js&"
export * from "./md-lazy.vue?vue&type=script&lang=js&"
import style0 from "./md-lazy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/X4KPpxnC/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c71d9ec')) {
      api.createRecord('6c71d9ec', component.options)
    } else {
      api.reload('6c71d9ec', component.options)
    }
    module.hot.accept("./md-lazy.vue?vue&type=template&id=6c71d9ec&", function () {
      api.rerender('6c71d9ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/md-lazy.vue"
export default component.exports